<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> تعرفه خدمات  </span>

    </div>

</div>

<main style="direction: rtl;" class="container py-4 px-md-4 px-0">

    <!-- جدول نتایج -->

    <div class="mt-3 p-2" >

        <div class="section">

            <div [formGroup]="mdl_TripCost" class="container-fluid row gx-md-2 gx-0 gy-3 p-2">

                <!-- فرم جستجو -->

                <div class="position-relative col-12 p-2 mb-2">

                    <form class="col-12 row gx-md-2 gx-0 gy-3" [formGroup]="mdl_Search">

                        <!-- حوزه خدمت -->

                        <div class="col-12 col-md-auto position-relative">
                    
                            <label class="mb-2"> حوزه خدمت </label>

                            <select  class="form-select" formControlName="iMobileDomain">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Domain" [value]="item.iMobileDomain">
                                    
                                    {{item.strComment}} 
                                
                                </option>

                            </select>

                        </div>

                        <!-- جستجو -->

                        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

                            <button class="btn btn-primary w-100" (click)="search_Cost()">
                                    
                                &nbsp; جستجو &nbsp;

                                <i class="fa fa-search" aria-hidden="true"></i>
                            
                            </button>

                        </div>

                    </form>

                </div>

                <!-- ساعت شروع -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> ساعت شروع </label>
        
                    <div class="input-group clockpicker">

                        <input type="text" class="form-control p-2 text-center" id="Stime" formControlName="strOffitial_STime">

                        <span class="input-group-addon">

                        <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>
        
                </div>

                <!-- ساعت پایان -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> ساعت پایان </label>
        
                    <div class="input-group clockpicker">

                        <input type="text" class="form-control p-2 text-center" id="Etime" formControlName="strOffitial_ETime">

                        <span class="input-group-addon">

                        <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>
        
                </div>

                <!-- نرخ هر دقیقه حضور (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر دقیقه حضور (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_PresenceFee">
        
                </div>

                <!-- نرخ هر دقیقه اضافه کاری (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر دقیقه اضافه کاری (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_Overtime">
        
                </div>
                
                <!-- نرخ هر دقیقه توقف (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر دقیقه توقف (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_StopFee">
        
                </div>
                
                <!-- نرخ هر دقیقه سفر (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر دقیقه سفر (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_TripTimeFee">
        
                </div>
                
                <!-- نرخ هر دقیقه حرکت (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر دقیقه حرکت (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_MoveFee">
        
                </div>
                
                <!-- نرخ هر کیلومتر حرکت(ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر کیلومتر حرکت(ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_InDomainFee">
        
                </div>
                
                <!-- نرخ هر کیلومتر ماموریت (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر کیلومتر ماموریت (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_OutDomainFee">
        
                </div>
                
                <!-- نرخ هر سفر (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر سفر (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_Trip">
        
                </div>
                
                <!-- پاداش سفرهای شناور (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> پاداش سفرهای شناور (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_PercentageIncrease">
        
                </div>
                
                <!-- نرخ هر وعده غذایی در ماموریت (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> نرخ هر وعده غذایی در ماموریت (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_MealFee">
        
                </div>
                
                <!-- مبلغ ثابت سختی خدمات در ماه (ریال) -->

                <div class="position-relative col-12 col-md-4 p-2">
        
                    <label class="mb-2 text-muted"> مبلغ ثابت سختی خدمات در ماه (ریال) </label>
        
                    <input class="form-control p-2 text-center" formControlName="iOffitial_DifficultyService">
        
                </div>

                <!-- ویرایش اطلاعات -->

                <div class="position-relative col-12 p-2">

                    <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

                        <button class="btn btn-success " (click)="editForm()" [disabled]="mdl_TripCost.get('iMobileDomain')?.value == -1" > 
                            
                            &nbsp; ویرایش تعرفه &nbsp; 
                        
                        </button>

                    </div>

                </div>
        
            </div>
    
        </div>

    </div>

</main>